import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export const toastNotification = (message: string, colour?: string) => {
	toast(message, {
		className: colour && `${colour}`,
	});
};
